import script from "./addStudentSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./addStudentSchedule.vue?vue&type=script&setup=true&lang=js"

import "./addStudentSchedule.vue?vue&type=style&index=0&id=285e882e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285e882e"]])

export default __exports__